import type { CSSProperties } from 'react'
import { RADOM_COLORS } from '../util/Constants'

export const loadingWrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: 140,
  gap: 20
}

export const containerStyle: CSSProperties = {
  flexDirection: 'column',
  fontSize: 14,
  gap: 30
}

export const topBarStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}

export const sectionTitle18Style: CSSProperties = {
  fontSize: 18
}

export const refundHeaderStyle: CSSProperties = {
  fontSize: '18px',
  paddingBottom: 5,
  display: 'flex',
  flexDirection: 'row',
  gap: 10,
  alignItems: 'center'
}

export const refundHeaderAmountRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: '32px'
}

export const assetLogo32Style: CSSProperties = {
  width: 32,
  height: 'auto',
  maxHeight: 32
}

export const tickerBadgeStyle: CSSProperties = {
  background: RADOM_COLORS.GRAY_MED,
  color: RADOM_COLORS.BLACK,
  borderRadius: 10,
  fontSize: 14,
  padding: '4px 10px',
  fontWeight: 400
}

export const idRowStyle: CSSProperties = {
  display: 'flex',
  gap: 4
}

export const iconButtonNoPaddingStyle: CSSProperties = {
  padding: 0
}

export const copyIconStyle: CSSProperties = {
  width: 17
}

export const ledgerRowStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  gap: 6
}

export const ledgerSecondaryTextStyle: CSSProperties = {
  color: RADOM_COLORS.GRAY4
}

export const assetRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 4
}

export const paymentMethodMarginRight4Style: CSSProperties = {
  marginRight: 4
}

export const amountRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  fontSize: 14
}
